import React from "react";
import { GetShadeCol } from "../../Layout-Components/Editor-Layout/Three-JS-Viewer/Controllers/RefreshShade";
import { useViewerStore } from "../../../store/store";

type SolarPalletProps = {
    className?: string
}

type ShadeLegendBand = { min: number; max: number };

/** Solar access bands matching GetShadeCol thresholds (low → high) */
const SHADE_LEGEND_BANDS: ShadeLegendBand[] = [
    { min: 0, max: 30 },
    { min: 30, max: 50 },
    { min: 50, max: 55 },
    { min: 55, max: 60 },
    { min: 60, max: 65 },
    { min: 65, max: 70 },
    { min: 70, max: 75 },
    { min: 75, max: 80 },
    { min: 80, max: 85 },
    { min: 85, max: 90 },
    { min: 90, max: 95 },
    { min: 95, max: 100 },
];

const getBandLabel = (min: number, max: number) => `${min}% – ${max}%`;

const SolarPallet = (props: SolarPalletProps) => {
    const { className } = props;
    const modulesMultipliersEnabled = useViewerStore(state => state.modulesMultipliersEnabled);

    const legendBands = modulesMultipliersEnabled
        ? SHADE_LEGEND_BANDS
        : [{ min: 0, max: 50 }, ...SHADE_LEGEND_BANDS.filter(band => band.min >= 50)];

    const legendItems = legendBands.map(({ min, max }) => ({
        color: GetShadeCol(min, true) as string,
        label: getBandLabel(min, max),
    }));

    return (
        <>
            <div id="solarAccessLegend" className={`pallet ${className ?? ""}`}>
                <div className="pallet__values">
                    <span>0%</span>
                    <span>100%</span>
                </div>
                <div className="pallet__wrapper">
                    {legendItems.map(({ color, label }) => (
                        <div
                            className="pallet__item"
                            style={{backgroundColor: color}}
                            key={label}
                            title={`Solar Access: ${label}`}
                        ></div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default SolarPallet;
